// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.label-success[data-v-0e823ad0] {\n\tmargin: 5px;\n\tpadding: 2px 5px;\n\t/*color: #fff;\n\tbackground-color: #536dfe;*/\n}\n", ""]);
// Exports
module.exports = exports;
